import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, Select, MenuItem } from "@material-ui/core";
import PropTypes from "prop-types";

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customStyles from 'views/component/Styles.js';
import ToggleInput from "./ToggleInput";

const useStyles = makeStyles(styles);
const useCustomStyles = makeStyles(customStyles);
const useSelectStyles = makeStyles(selectStyles);

export default function SimpleForm(props) {
    const { domain, tableName, params, onChange, onSave, onCancel, selectForm, selectFilter,
        insertAttr, readOnly, writeOnly, data } = props;
    const classes = { ...useStyles(), ...useCustomStyles(), ...useSelectStyles() };

    const [cols, setCols] = useState([]);
    const [width, setWidth] = useState('');
    const [editData, setEditData] = useState({});
    const [originalData, setOriginalData] = useState({});
    const [editMode, setEditMode] = useState(writeOnly);
    const [selectForms, setSelectForms] = useState({});

    const mounted = useRef(true);
    useEffect(() => {
        return () => { mounted.current = false }
    }, []);

    useEffect(() => {
        const count = cols.length;
        if (count > 5) {
            [4, 6].forEach(width => count % width === 0 && setWidth(12 / width));
        } else {
            setWidth(true);
        }
    }, [cols])

    useEffect(() => {
        if (data) {
            setOriginalData(data);
            setEditData(data);
        } else {
            axios.get(domain + '/list/' + tableName, { params: params }).then(response => {
                if (mounted.current) {
                    setCols(response.data.cols);
                    if (response.data.data.length === 1) {
                        setOriginalData(response.data.data[0]);
                        setEditData(response.data.data[0]);
                    } else {
                        let temp = { insert: true, ...insertAttr };
                        response.data.cols.forEach(col => {
                            if (!temp[col.colName]) {
                                temp[col.colName] = col.type === 'number' ? 0 : ''
                            }
                        });
                        setOriginalData(temp);
                        setEditData(temp);
                    }
                }
            });
        }
    }, [data]);

    useEffect(() => {
        if (selectForm) {
            let temp = {};
            Object.keys(selectForm).filter(key => !selectForm[key].table).forEach(key => temp[key] = selectForm[key]);

            const reqList = Object.keys(selectForm).filter(key => selectForm[key].table);
            axios.all(reqList.map(colName =>
                axios.get(domain + '/list/' + selectForm[colName].table)
            )).then(axios.spread((...responseList) => {
                if (mounted.current) {
                    reqList.forEach((colName, index) => {
                        const setting = selectForm[colName];
                        temp[colName] = responseList[index].data.data.map(item => ({ label: item[setting.label], value: item[setting.value] }));
                    });
                    setSelectForms(temp);
                }
            }));
        }
    }, [selectForm, insertAttr, domain]);

    const handleSave = function () {
        let temp = { ...editData };
        Object.entries(temp).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                temp[key] = value.join(',');
            }
        });

        axios.post(domain + '/listedit/' + tableName, [temp]).then(response => {
            if (mounted.current) {
                setEditMode(writeOnly || false);
                setOriginalData(editData);
                if (onSave) {
                    onSave(editData);
                }
            }
        });
    }

    const handleValueChange = function (colName, value) {
        let tempData = { ...editData };
        tempData[colName] = value;
        tempData.update = true;
        setEditData(tempData);
        if (onChange) {
            onChange(colName, value, tempData);
        }
    }
    const drawSelectForm = function (colInfo) {
        const itemList = (selectFilter[colInfo.colName] ? selectFilter[colInfo.colName](editData, selectForms[colInfo.colName]) : selectForms[colInfo.colName]);
        return <FormControl fullWidth className={classes.selectFormControlInfo}>
            <Select MenuProps={{ className: classes.selectMenu }} classes={{ select: classes.select }}
                value={editData[colInfo.colName]}
                onChange={e => { handleValueChange(colInfo.colName, e.target.value) }}
                inputProps={{ id: colInfo.colName }}>
                {itemList.map((item) => {
                    return <MenuItem classes={{ root: classes.selectMenuItemInfo, selected: classes.selectMenuItemSelectedInfo }}
                        value={item.value} key={item.value}>
                        {item.label}
                        {item.image ? <img src={item.image.src} width={item.image.width} style={{ marginLeft: 10 }} alt={item.value} /> : ''}
                    </MenuItem>;
                })}
            </Select>
        </FormControl>
    }

    const getButtons = function () {
        if (readOnly) {
            return ''
        } else if (editMode) {
            return (
                <GridItem xs={12} md={12}>
                    <Button color="success" className={classes.right} size="sm" onClick={handleSave}>저장</Button>
                    <Button color="danger" className={classes.right} size="sm"
                        onClick={e => {
                            setEditData(originalData);
                            setEditMode(writeOnly || false);
                            if (onCancel) onCancel();
                        }}>취소</Button>
                </GridItem>
            )
        } else {
            return <GridItem xs={12} md={12}>
                <Button color="infoOutline" className={classes.right} size="sm" onClick={e => { setEditMode(true) }}>수정</Button>
            </GridItem>
        }
    }
    return (
        <GridContainer>
            {getButtons()}
            {cols.map(col => {
                return col.ordr === 0 || (col.isFixed && !editData[col.colName]) || editData[col.colName] === undefined
                    ? '' : <GridItem key={col.colName} md={width}>
                        <ToggleInput edit={editMode && !col.isFixed} label={col.korName} name={col.colName}
                            value={editData[col.colName]} type={col.type}
                            onChange={handleValueChange} />
                    </GridItem>
            })}
        </GridContainer>
    );
}

SimpleForm.defaultProps = {
    readOnly: false,
};

SimpleForm.propTypes = {
    domain: PropTypes.string,
    tableName: PropTypes.string,
    params: PropTypes.object,
    selectForm: PropTypes.object,
    readOnly: PropTypes.bool,
    writeOnly: PropTypes.bool,
    onSave: PropTypes.func,
};